// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.current-color {\n  height: 28px !important;\n  border-radius: 4px !important;\n}\n.color-input {\n  padding: 0px 15px;\n  margin-right: 4px;\n  height: 28px !important;\n}\n.el-input__inner[errorColor='true'] {\n  background-color: #ff8a8a;\n}\n.el-input-number[errorColor='true'] .el-input__inner {\n  background-color: #ff8a8a;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
